export default __webpack_public_path__ + "static/media/derm.3fa3da0b.svg";